import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { NotificationServices } from "../services/NotificationServices";
import CustomPagination from "../utils/paginationUtils";
import SearchIcon from "../assets/searchIcon.svg";
import EditIcon from "../assets/editIcon.svg";
import "./AllCaseStagesInfo.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import EditStageInfo from "./EditStageInfo";
const AllCaseStagesInfo = () => {
  const [caseStageData, setCaseStageData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedStage, setSelectedStage] = useState(null);
  const searchTimeRef = useRef();
  const limit = 15;
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const getCaseStageData = async () => {
    setLoading(true);
    try {
      const res = await NotificationServices.getSubMasterStages(
        limit,
        "",
        page,
        searchKey
      );

      setCaseStageData(res?.data?.subMasterStages);
      setTotalPages(Math.ceil(res?.data?.total / limit));
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCaseStageData();
  }, [page, searchKey]);
  return (
    <div className="case-stages-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp;Case Stages Info
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">Case Stages Info</div>
        <div className="flex gap-2 items-center">
          <div
            style={{ border: "1px solid #E4E4E4" }}
            className="flex items-center gap-2 bg-white rounded-[8px] px-4 py-[6px] "
          >
            <img src={SearchIcon} alt="search-icon" />
            <input
              type="text"
              placeholder="Search anything"
              style={{ border: "0" }}
              className="outline-none"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      {loading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className={` grid grid-cols-7   text-[18px] px-8`}>
            <div className="col-span-2">
              <div className=" text-[#191919] font-semibold mb-4">
                CC Stage Status
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                CC Stage Text
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                HSA Stage Status
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                HSA Stage Text
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                Next Step User
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] text-center font-semibold mb-4">
                {" "}
                Action
              </div>
            </div>
          </div>
          {caseStageData && caseStageData.length > 0 ? (
            caseStageData?.map((stage, idx) => {
              return (
                <div
                  key={idx}
                  className={` py-6 px-8 rounded-[16px] ${
                    idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                  }`}
                >
                  <div className={`grid grid-cols-7  text-[#797979] `}>
                    <div className="col-span-2">
                      {stage?.commandCenterStageStatus || "--"}
                    </div>
                    <div>{stage?.commandCenterStageText || "--"}</div>
                    <div>{stage?.hsaWebStatus || "--"}</div>
                    <div>{stage?.hsaStageWebText || "--"}</div>
                    <div>{stage?.nextStepUser || "--"}</div>
                    <div className="flex justify-center">
                      {" "}
                      <img
                        src={EditIcon}
                        alt="edit-icon"
                        className="h-[30px] w-[30px] cursor-pointer"
                        onClick={() => setSelectedStage(stage)}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-xl flex items-center justify-center mt-5 font-semibold h-[300px]">
              No Data Found
            </div>
          )}
        </div>
      )}
      <div className="flex justify-center items-center mt-5 ">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
      {selectedStage && (
        <EditStageInfo
          selectedStage={selectedStage}
          setOpen={setSelectedStage}
          getCaseStageData={getCaseStageData}
        />
      )}
    </div>
  );
};

export default AllCaseStagesInfo;
